import yup from 'src/libraries/validator.library';

export const RiskAssessmentSchema = yup
  .object()
  .shape({
    requestId: yup.number().nullable(),
    picExperienceInModal: yup.number().nullable(),
    consecDaysOnDuty: yup.number().nullable(),
    dutyDay: yup.number().nullable(),
    ceilingVisibility: yup.number().nullable(),
    densityAltitude: yup.number().nullable(),
    windsInMissionArea: yup.number().nullable(),
    terrain: yup.number().nullable(),
    missionType: yup.number().nullable(),
    landingZone: yup.number().nullable(),
    picCurrencyInMission: yup.number().nullable(),
    picExperienceInMission: yup.number().nullable(),
    dutyDayWOCL: yup.number().nullable(),
    timeOfDay: yup.number().nullable(),
    mitigationDesc: yup.string().nullable(),
    riskScore: yup.number(),
  })
  .defined();

export const RiskAssessmentPayloadSchema = yup
  .object()
  .shape({
    riskAssessment: RiskAssessmentSchema,
  })
  .defined();

export const RiskAssessmentFormSchema = yup
  .object()
  .shape({
    picExperienceInModal: yup.mixed().required(),
    consecDaysOnDuty: yup.mixed().required(),
    dutyDay: yup.mixed().required(),
    dutyDayWOCL: yup.mixed().nullable(),
    picCurrencyInMission: yup.mixed().required(),
    picExperienceInMission: yup.mixed().required(),
    ceilingVisibility: yup.mixed().required(), // 6. Ceiling / Visibility
    densityAltitude: yup.mixed().required(), // 7. Density Altitude
    windsInMissionArea: yup.mixed().required(), // 8. Winds In Mission Area
    terrain: yup.mixed().required(), // 9. Terrain
    timeOfDay: yup.mixed().required(), // 10. Time Of Day
    missionType: yup.mixed().required(), // 11. Mission Type
    landingZone: yup.mixed().required(), // 12. Landing Zone
    mitigationDesc: yup.string().nullable(),
  })
  .defined();

export type IRiskAssessmentSchema = yup.InferType<typeof RiskAssessmentSchema>;
export type IRiskAssessmentFormSchema = yup.InferType<
  typeof RiskAssessmentFormSchema
>;
